import ExpiredEventScreen from './expiredEventScreen';
export default ExpiredEventScreen;
